<template>
	<div id="tags-view-container" class="tags-view-container">

		<el-tabs v-model="activeTab" type="card" :closable="false" @tab-remove="closeTab" @tab-click="linkTo"
			@click.middle.prevent.native="middleClick" @contextmenu.prevent.native="rightClick($event)">
			<el-tab-pane v-for="(tag, index) in visitedViews" :key="tag.path" :label="getTitleByPermission(tag)"
				:name="tag.path" :closable="!isAffix(tag)">
			</el-tab-pane>
		</el-tabs>

		<ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
			<li @click="refreshSelectedTag(selectedTag)">{{ $t('tagsView.refresh') }}</li>
			<li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">{{ $t('tagsView.close') }}</li>
			<li @click="closeOthersTags">{{ $t('tagsView.closeOthers') }}</li>
			<li @click="closeAllTags(selectedTag)">{{ $t('tagsView.closeAll') }}</li>
		</ul>

	</div>
</template>

<script>
	import {mapGetters} from 'vuex';
	import Bus from '@/utils/bus';
	import {generateTitle} from '@/utils/i18n'
	import path from 'path';
	import {tagviewsMixins} from '@/utils/mixins.js';

	export default {
		mixins:[tagviewsMixins],
		data() {
			return {
				activeTab: '',
				visible: false,
				top: 0,
				left: 0,
				selectedTag: {},
				affixTags: []
			}
		},
		computed: {
			visitedViews() {
				let list = [];
				for (const item of this.$store.state.tagsView.visitedViews) {
					list.push(item.name);
				}
				if (!list.includes('customerPageIndex')) {
					localStorage.removeItem('customer-page-list-query');
				}
				return this.$store.state.tagsView.visitedViews
			},
			routes() {
				return this.$store.state.permission.routes
			},
			...mapGetters([
				'permission_menus'
			])
		},
		watch: {
			$route(value) {
				this.activeTab = value.path;
				this.addTags()
				// this.moveToCurrentTag()
			},
			visible(value) {
				if (value) {
					document.body.addEventListener('click', this.closeMenu)
				} else {
					document.body.removeEventListener('click', this.closeMenu)
				}
			}
		},
		mounted() {
			this.initTags()
			this.addTags()

			let el = document.querySelector(".el-tabs__nav");
			let sortTabs = Sortable.create(el, {
				animation: 200,
				filter: ".el-icon-close",
				onMove: function(evt) {
					if (evt.dragged.id.includes('/welcome')) {
						return false;
					}
					if (evt.related) {
						return evt.related.id !== 'tab-/welcome';
					}
				}
			});

			this.activeTab = this.$route.path;
		},
		methods: {
			eventToPath(e) {
				let target = "";

				function getTarget(node) {
					if (typeof node.className === "undefined") return null;
					if (node.className.includes("el-tabs__item")) {
						return node;
					} else {
						return getTarget(node.parentNode);
					}
				}

				target = getTarget(e.target);
				if (!target) return null;
				return /\/[\s\S]*/.exec(target.id)[0]; // 从TAB的ID中解析出path
			},
			linkTo(data) {
				let path = data.name;
				let routeData = this.visitedViews.find(view => view.path == path);
				this.$router.push(routeData);
			},
			// closeTab(path) {
			// 	let routeData = this.visitedViews.find(view => view.path == path);
			// 	this.closeSelectedTag(routeData);
			// },
			middleClick(e) {
				let path = this.eventToPath(e);
				let routeData = this.visitedViews.find(view => view.path == path);
				this.closeSelectedTag(routeData);
			},
			rightClick(event) {
				let path = this.eventToPath(event);
				// path为null时，说明没点在tab-item上
				if (!path) return false;
				let routeData = this.visitedViews.find(view => view.path == path);
				this.openMenu(routeData, event)
			},
			generateTitle, // generateTitle by vue-i18no
			getTitleByPermission(tag) {
				let title = "";

				function recursionSearch(nodes) {
					if (!nodes || nodes.length < 1) return false;
					for (let item of nodes) {
						if (item.menuUrl == tag.path) {
							title = item.menuName;
							return true;
						}
						recursionSearch(item.nodes);
					}
				}
				recursionSearch(this.permission_menus);
				title = title || tag.meta.title;
				return title;
			},
			// isActive(route) {
			// 	return route.path === this.$route.path
			// },
			isAffix(tag) {
				return tag.meta && tag.meta.affix
			},
			// 生成tags
			filterAffixTags(routes, basePath = '/') {
				let tags = []
				routes.forEach(route => {
					if (route.meta && route.meta.affix) {
						const tagPath = path.resolve(basePath, route.path)
						tags.push({
							fullPath: tagPath,
							path: tagPath,
							name: route.name,
							meta: {
								...route.meta
							}
						})
					}
					if (route.children) {
						const tempTags = this.filterAffixTags(route.children, route.path)
						if (tempTags.length >= 1) {
							tags = [...tags, ...tempTags]
						}
					}
				})
				return tags
			},
			initTags() {
				const affixTags = this.affixTags = this.filterAffixTags(this.routes)
				for (const tag of affixTags) {
					// Must have tag name
					if (tag.name) {
						this.$store.dispatch('tagsView/addVisitedView', tag)
					}
				}
			},
			addTags() {
				const {
					name
				} = this.$route
				if (name) {
					this.$store.dispatch('tagsView/addView', this.$route)
				}
				return false
			},
			/*moveToCurrentTag() {
			  const tags = this.$refs.tag
			  this.$nextTick(() => {
			    for (const tag of tags) {
			      if (tag.to.path === this.$route.path) {
			        // this.$refs.scrollPane.moveToTarget(tag)
			        // when query is different then update
			        if (tag.to.fullPath !== this.$route.fullPath) {
			          this.$store.dispatch('tagsView/updateVisitedView', this.$route)
			        }
			        break
			      }
			    }
			  })
			},*/


			removeCacheByCondition(visitedViews, condition) {
				let _visitedViews = visitedViews;
				for (let i = 0, len = _visitedViews.length; i < len; i++) {
					if (condition(_visitedViews[i])) {
						Bus.$emit("removeCache", "closeSelectedTag", _visitedViews[i]);
					}
				}
			},



			// refreshSelectedTag(_view) {
			// 	let view = this.$route;
			// 	this.$store.dispatch('tagsView/delCachedView', view).then(() => {
			// 		const {
			// 			fullPath
			// 		} = view
			// 		this.$nextTick(() => {
			// 			this.$router.replace({
			// 				path: '/redirect' + fullPath
			// 			})
			// 		})
			// 	})
			// 	Bus.$emit("removeCache", "closeSelectedTag", this.$route);
			// },

			// closeSelectedTag(view) {
			// 	if (view.path == "/welcome") {
			// 		return
			// 	}
			// 	this.$store.dispatch('tagsView/delView', view).then(({
			// 		visitedViews
			// 	}) => {
			// 		if (this.isActive(view)) {
			// 			this.toLastView(visitedViews, view)
			// 			const latestView = visitedViews.slice(-1)[0];
			// 			if (latestView) {
			// 				this.$router.push(latestView);
			// 			} else {
			// 				this.$router.push("/");
			// 			}
			// 		}
			// 		//关闭单个
			// 		Bus.$emit("removeCache", "closeSelectedTag", view);
			// 	})
			// },

			closeOthersTags() {
				Bus.$emit("removeCache", "closeOthersTags", this.visitedViews);
				this.$router.push(this.selectedTag)
				this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
					// this.moveToCurrentTag()
				})
			},

			closeAllTags(view) {
				Bus.$emit("removeCache", "closeAllTags", view);
				this.$store.dispatch('tagsView/delAllViews').then(({
					visitedViews
				}) => {
					if (this.affixTags.some(tag => tag.path === view.path)) {
						return
					}
					this.toLastView(visitedViews, view)
				})
			},



			// toLastView(visitedViews, view) {
			// 	const latestView = visitedViews.slice(-1)[0]
			// 	if (latestView) {
			// 		this.$router.push(latestView.fullPath)
			// 	} else {
			// 		// now the default is to redirect to the home page if there is no tags-view,
			// 		// you can adjust it according to your needs.
			// 		if (view.name === 'Dashboard') {
			// 			// to reload home page
			// 			this.$router.replace({
			// 				path: '/redirect' + view.fullPath
			// 			})
			// 		} else {
			// 			this.$router.push('/')
			// 		}
			// 	}
			// },
			openMenu(tag, e) {
				const menuMinWidth = 105
				const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
				const offsetWidth = this.$el.offsetWidth // container width
				const maxLeft = offsetWidth - menuMinWidth // left boundary
				const left = e.clientX - offsetLeft + 15 // 15: margin right

				if (left > maxLeft) {
					this.left = maxLeft
				} else {
					this.left = left
				}

				this.top = e.clientY
				this.visible = true
				this.selectedTag = tag
			},
			closeMenu() {
				this.visible = false
			},
			handleScroll() {
				this.closeMenu()
			},
			findView(path) {
				return this.visitedViews.find(item => item.path == path);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tags-view-container {
		height: max-content;
		padding-top: 8px;
		width: 100%;
		background: #fff;
		border-bottom: 1px solid #d8dce5;

		/*box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);*/
		.tags-view-wrapper {
			.tags-view-item {
				display: inline-block;
				position: relative;
				cursor: pointer;
				height: 26px;
				line-height: 26px;
				/*border: 1px solid #d8dce5;*/
				color: #495060;
				background: #F6F7F9;
				padding: 0 8px;
				font-size: 12px;
				margin-left: 5px;
				margin-top: 6px;
				border-top-left-radius: 7px;
				border-top-right-radius: 7px;

				&:first-of-type {
					margin-left: 15px;
				}

				&:last-of-type {
					margin-right: 15px;
				}

				&.active {
					background-color: #fff;
					color: #0F81FB;
					/*border-color: #F6F7F9;*/
					border: 1px solid #d8dce5;
					border-bottom: 1px solid #fff;
					height: 28px;
					border-top-left-radius: 7px;
					border-top-right-radius: 7px;

					&::before {
						content: '';
						background: #337EFF;
						display: inline-block;
						width: 8px;
						height: 8px;
						border-radius: 50%;
						position: relative;
						margin-right: 2px;
					}
				}
			}
		}

		.contextmenu {
			margin: 0;
			background: #fff;
			z-index: 3000;
			position: absolute;
			list-style-type: none;
			padding: 5px 0;
			border-radius: 4px;
			font-size: 12px;
			font-weight: 400;
			color: #333;
			box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

			li {
				margin: 0;
				padding: 7px 16px;
				cursor: pointer;

				&:hover {
					background: #eee;
				}
			}
		}
	}
</style>

<style lang="scss">
	#tags-view-container {
		$tab-height: 30px;
		$arrow-width: 10px;
		$arrow-height: 16px;
		$arrow-hover-color: hsla(218, 100%, 60%, 1);
		$item-space: 4px;

		.el-tabs {
			height: $tab-height - 1px;
		}

		//reset element css of el-icon-close
		.tags-view-wrapper {
			.tags-view-item {
				.el-icon-close {
					width: 16px;
					height: 16px;
					vertical-align: 2px;
					border-radius: 50%;
					text-align: center;
					transition: all .3s cubic-bezier(.645, .045, .355, 1);
					transform-origin: 100% 50%;

					&:before {
						transform: scale(.6);
						display: inline-block;
						vertical-align: -3px;
					}

					&:hover {
						background-color: #b4bccc;
						color: #fff;
					}
				}
			}
		}

		.el-tabs__header {
			border-bottom-color: rgb(217, 217, 217);

			padding: 0 8px;
		}

		.tags-view-container {}

		.el-tabs__nav-scroll {
			// height: $tab-height;
		}

		.el-tabs__nav {
			border-width: 0;

			&>.el-tabs__item+.el-tabs__item {
				margin-left: $item-space;
			}
		}

		.el-tabs__item {
			font-size: 12px;
			position: relative;
			height: $tab-height;
			border: 1px solid hsla(0, 0%, 85%, 1);
			// border-bottom-color: white;
			background: hsla(220, 20%, 97%, 1);
			border-radius: 4px 4px 0px 0px;
			line-height: $tab-height;
			color: rgb(80, 85, 89);

			border-color: #f6f7f9;
			// rgb(217, 217, 217)
		}

		.el-tabs__item::before {
			position: absolute;
			content: "1234";
			background: rgb(217, 217, 217);
			height: 1px;
			width: calc(100% + 2px);
			bottom: -1px;
			left: -1px;
		}

		.is-active {
			color: #1890ff;
			border-color: rgb(217, 217, 217);
		}

		.el-tabs__item:first-chlid {
			margin-left: 10px;
		}

		.el-tabs--card>.el-tabs__header {}

		.is-active {
			background: white;
			position: relative;

			// border-bottom-color: white;
			// color: white;  //修改激活表头字体颜色，默认是蓝色
			&::before {
				content: "";
				position: absolute;
				left: 0;
				bottom: -1px;
				width: 100%;
				height: 1px;
				background: white;
			}
		}

		.is-scrollable {
			padding: 0 25px;
		}

		.el-tabs__nav-next,
		.el-tabs__nav-prev {
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid rgb(217, 217, 217);
			width: 24px;
			height: $tab-height;

			&:hover {
				border-color: hsla(211, 25%, 82%, 1);
				background: hsla(219, 100%, 95%, 1);
			}
		}

		.el-tabs__nav-next {
			border-top-right-radius: 4px;

			&>.el-icon-arrow-right {
				position: relative;
				height: $arrow-height;
				width: $arrow-width;
			}

			&>.el-icon-arrow-right::before {
				content: "";
				position: absolute;
				top: 0;
				left: 0;
				border-width: $arrow-height /2 0 $arrow-height / 2 $arrow-width;
				border-color: hsla(212, 12%, 79%, 0);
				border-left-color: hsla(212, 12%, 79%, 1);
				border-style: solid;
			}

			&:hover {
				&>.el-icon-arrow-right::before {
					border-left-color: $arrow-hover-color;
				}
			}
		}

		.el-tabs__nav-prev {
			border-top-left-radius: 4px;

			&>.el-icon-arrow-left {
				position: relative;
				height: $arrow-height;
				width: $arrow-width;
			}

			&>.el-icon-arrow-left::before {
				content: "";
				position: absolute;
				top: 0;
				right: 0;
				border-width: $arrow-height / 2 $arrow-width $arrow-height / 2 0;
				border-color: hsla(212, 12%, 79%, 0);
				border-right-color: hsla(212, 12%, 79%, 1);
				border-style: solid;
			}

			&:hover {
				&>.el-icon-arrow-left::before {
					border-right-color: $arrow-hover-color;
				}
			}
		}
	}
</style>
